import React from 'react';

const Disclaimer = () => {
  return (
    <section className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-full mx-auto px-8">
          <h2 className="text-2xl font-bold text-dark-grey mb-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            DISCLAIMER
          </h2>
          
          <div className="space-y-4 text-gray-900 leading-relaxed">
            <p className="font-semibold text-dark-grey">
              This website does NOT provide medical advice.
            </p>
            
            <p>
              TP Wellness Therapies does not claim to diagnose or cure any medical condition. 
              Bioresonance Therapies can help alleviate pain in a wide range of conditions (physical and mental).
            </p>
            
            <p>
              The information, including but not limited to, text, graphics, images and other material 
              contained on this website is for informational purposes only. No material on this site is 
              intended to be a substitute for professional medical advice, diagnosis or treatment. Always 
              seek the advice of your GP or another qualified healthcare provider with any questions you 
              may have regarding a medical condition or treatment and before undertaking a new healthcare 
              regimen, and never disregard professional medical advice or delay in seeking it because of 
              something you have read on this website.
            </p>
            
            <div className="bg-yellow-50 border-l-4 border-gold p-4 rounded-r-lg">
              <p className="font-semibold text-dark-grey mb-2">
                Caution/Warning:
              </p>
              <p>
                Bioresonance Therapy is not recommended for pregnant women and patients with pacemakers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
